var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterConsultation2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#2F75DA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.25 6.75H11.25C10.7859 6.75 10.3408 6.93437 10.0126 7.26256C9.68437 7.59075 9.5 8.03587 9.5 8.5V22.5C9.5 22.9641 9.68437 23.4092 10.0126 23.7374C10.3408 24.0656 10.7859 24.25 11.25 24.25H21.75C22.2141 24.25 22.6592 24.0656 22.9874 23.7374C23.3156 23.4092 23.5 22.9641 23.5 22.5V12M18.25 6.75L23.5 12M18.25 6.75V12H23.5M20 16.375H13M20 19.875H13M14.75 12.875H13",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterConsultation2);
export default __webpack_public_path__ + "static/media/afterConsultation-2.e28b4d10325d493953bc6e33ea9df410.svg";
export { ForwardRef as ReactComponent };